import React from "react";
import { Link } from "react-router-dom";
import {
  FaMapMarkerAlt,
  FaBed,
  FaBath,
  FaRulerCombined,
} from "react-icons/fa";
import { API_URL } from "../../../config/api"; 

export default function PropertyCard({ property }) {

  // Xử lý ảnh
  // Xử lý ảnh
  let propertyImages = [];
  try {
    if (typeof property.images === "string") {
      const parsed = JSON.parse(property.images || "[]");
      if (Array.isArray(parsed)) propertyImages = parsed;
    } else if (Array.isArray(property.images)) {
      propertyImages = property.images;
    }
  } catch (err) {
    console.error("Lỗi parse images:", err);
  }

  const imageSrc = propertyImages.length
    ? propertyImages[0].startsWith("http")
      ? propertyImages[0]
      : `${API_URL}${propertyImages[0]}`
    : "/no-image.jpg";


  // Bản đồ loại hình
  const typeMap = {
    apartment: "Căn hộ",
    villa: "Biệt thự",
    shophouse: "Shophouse",
    condotel: "Condotel",
    penthouse: "Penthouse",
    duplex: "Duplex",
  };

  // Trạng thái duyệt tin
  const statusColor = {
    pending: "bg-yellow-500",
    approved: "bg-green-600",
    rejected: "bg-red-500",
  }[property.status];

  // Xử lý hiển thị giá
  const displayPrice =
    property.transactionType === "rent"
      ? property.rentPrice
        ? `${property.rentPrice.toLocaleString("vi-VN")} ₫ / tháng`
        : "Giá thuê thỏa thuận"
      : property.price
        ? `${property.price.toLocaleString("vi-VN")} ₫`
        : "Giá bán thỏa thuận";

  return (
    <Link
      to={`/properties/${property.id}`}
      className="border rounded-lg overflow-hidden shadow-sm hover:shadow-md transition flex flex-col"
    >
      <div className="relative">
        <img
          loading="lazy"
          src={imageSrc}
          alt={property.projectName}
          className="w-full h-48 object-cover"
        />
        <span
          className={`absolute top-2 left-2 text-xs text-white px-2 py-1 rounded ${statusColor}`}
        >
          {property.status === "approved"
            ? "Đã duyệt"
            : property.status === "pending"
              ? "Chờ duyệt"
              : "Từ chối"}
        </span>

        {/* Gắn nhãn "Bán" hoặc "Cho thuê" */}
        <span
          className={`absolute top-2 right-2 text-xs px-2 py-1 rounded ${property.transactionType === "rent"
            ? "bg-blue-600 text-white"
            : "bg-red-600 text-white"
            }`}
        >
          {property.transactionType === "rent" ? "Cho thuê" : "Bán"}
        </span>
      </div>

      <div className="p-3 text-sm text-blue-900 space-y-1 flex flex-col flex-1">
        <h3 className="font-semibold text-base line-clamp-2">
          {property.projectName || property.title}
        </h3>
        <p className="text-gray-600 text-xs">{typeMap[property.propertyType]}</p>

        <div className="flex justify-between flex-wrap gap-2 text-gray-700 text-xs">
          <span className="flex items-center gap-1">
            <FaBed /> {property.bedrooms} PN
          </span>
          <span className="flex items-center gap-1">
            <FaBath /> {property.bathrooms} PT
          </span>
          <span className="flex items-center gap-1">
            <FaRulerCombined /> {property.area} m²
          </span>
        </div>

        {/* Giá hiển thị động */}
        <p className="text-red-600 font-bold text-lg">{displayPrice}</p>

        <p className="text-xs text-gray-500 flex items-center gap-1 mt-auto">
          <FaMapMarkerAlt /> {property.location}
        </p>
      </div>
    </Link>
  );
}
